let
    $document = Voonto.$(document),
    redesSticky = document.querySelector('.herramientas.fija'),
    marcador = document.querySelector('.marcador')
;
let redes = redesSticky ? redesSticky.nextElementSibling : null;
let estadoRedes = 'relativo';

function redesFijo() {
    redesSticky.classList.add('redesVisible')
    return 'fijo';
}

function redesRelativo() {
    redesSticky.classList.remove('redesVisible')
    return 'relativo';
}

var handleScroll = nibara.nTools.throttle(50, function handleScroll() {
    //Logger.info('SocialToolbar handleScroll');
    
    var bottom = redes.getBoundingClientRect().bottom;
    var offset = (marcador) ? marcador.offsetHeight : 0;
    if (bottom <= offset && estadoRedes === 'relativo') {
        estadoRedes = redesFijo();
    }
    if (bottom > offset && estadoRedes === 'fijo') {
        estadoRedes = redesRelativo();
    }
});

class SocialToolbar {
    constructor(form) {
        this.isEnabled = false;
    }

    enable() {
        Logger.info('SocialToolbar enable. isEnabled: ' + this.isEnabled);
        if (redesSticky && redes && !this.isEnabled) {
            handleScroll();
            $document.on('scroll', handleScroll);
            this.isEnabled = true;
        }
    }

    disable() {
        Logger.info('SocialToolbar disable. isEnabled: ' + this.isEnabled);
        if (this.isEnabled) {
            $document.off('scroll', handleScroll);
            this.isEnabled = false;
            redesSticky.classList.remove('redesVisible')
        }
    }
}
export default SocialToolbar;



// WEBPACK FOOTER //
// ./src/scripts/layout/social-toolbar.js